
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EmpresasComponent } from 'app/finanzas/components/empresas/empresas.component';
import { FinanzasComponent } from './finanzas.component';
import { MovimientosComponent} from 'app/finanzas/components/movimientos/movimientos.component';
import { MovimientosxAnioComponent } from './components/movimientosx-anio/movimientosx-anio.component';
import { ComprobanteComponent } from './components/comprobante/comprobante.component';
import { ComprobantexAnioComponent } from './components/comprobantex-anio/comprobantex-anio.component';
import { InformeComponent } from './components/informe/informe.component'
import { ValoracionComponent } from './components/valoracion/valoracion.component';
import { MenuValoracion } from './components/menu-valoracion/menu-valoracion.component';



const routes: Routes = [
  { path: 'finanzas', component:FinanzasComponent, 

  children: [
      {path: '', redirectTo:'empresas', pathMatch:'full'},
      {path: 'empresas', component: EmpresasComponent },
      {path: 'movimientos', component: MovimientosComponent},
      {path: 'movimientosAnio', component: MovimientosxAnioComponent}, 
      {path: 'comprobante', component: ComprobanteComponent  }, 
      {path: 'comprobanteAnio', component:ComprobantexAnioComponent}, 
      {path: 'informes', component: InformeComponent }, 

      
      {path: 'valoracionE', component:  ValoracionComponent },
      {path: 'menu', component: MenuValoracion }, 

      
      

  ]},


  

];

@NgModule({
  imports: [RouterModule.forRoot(routes)], 
  exports: [RouterModule]
})

export class Finanzas{}